if (!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.sliderElement = this.querySelector('[data-slider]');

      if (!this.sliderElement) return;

      this.options = {
        watchOverflow: true,
        draggable: true,
        loop: true, // Allows the slider to go from slide 3 back to slide 1
        autoplay: {
          delay: 5000, // 5000ms = 5 seconds between slides
          disableOnInteraction: false, // Keeps autoplaying even after user clicks a bullet
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
      };

      this.slider = new Swiper(this.sliderElement, this.options);
    }
  }

  customElements.define('hero-slider', HeroSlider);
}
